module.exports = __webpack_public_path__ + "img/loading.db76add6.gif";